import { call, put } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { Method } from '../../../../api/types';
import { ApiRequest } from '../../../../api/ApiService';
import { ENDPOINTS } from '../../../../api/constants';
import { SignQuoteParams, SignQuoteResponse } from '../../types';
import SuccessToast from '../../../../shared/components/toast/SuccessToast';
import ErrorToast from '../../../../shared/components/toast/ErrorToast';
import { totalPriceOverviewActions } from '../totalPriceOverviewSlice';

async function callApi(props: SignQuoteParams) {
  const queryParam = {
    clientId: props?.clientId,
  };
  return ApiRequest(Method.GET, ENDPOINTS.signQuote, undefined, queryParam);
}

export default function* callSignQuoteSaga({ payload }: PayloadAction<SignQuoteParams>) {
  try {
    const response: SignQuoteResponse = yield call(callApi, payload);
    if (response?.isSuccess) {
      yield put(totalPriceOverviewActions.signQuoteSuccess());
      SuccessToast('Succes!', 'Binnenkort ontvang je de aanbieding');
    } else {
      throw new Error('Sign quote error');
    }
  } catch (error: unknown) {
    console.error('callSignQuoteSaga', error);
    yield put(totalPriceOverviewActions.signQuoteFailure());
    ErrorToast(undefined, error?.toString());
  }
}
